import TablePannel from "./TablePannel";

export default TablePannel;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/tablePannel/index.js